"use strict";

var app = angular.module('app');

app.controller('storeController', ["$scope", "$filter", "productsService", "checkoutService", "siteVariablesService", "orderService", "LangService", "$translate", function ($scope, $filter, productsService, checkoutService, siteVariablesService, orderService, LangService, $translate) {
    const siteVariables = siteVariablesService.getVariables();

    $scope.ctx = {
        legal: false,
        products: new wijmo.collections.CollectionView(),
        cartItems: [],
        filter: '',
        countries: null,
        clientInformation: {
            buyer_type: "company",
            company_name: null,
            company_address: null,
            vat_number: null,
            phone: null,
            email: null,
            name: null,
            surname: null,
            country: null,
            city: null,
            address: null,
            zip: null,
            invoice: null,
            lang: siteVariables.locale,
            tax: siteVariables.tax,
            total_no_tax: null,
            total_with_tax: null,
            shipping_cost: 0,
            total: null,
            tax_value: null,
            shipping_group: null
        }
    };
    var clearCart = false;

    productsService.getProducts(siteVariables.productsUrl).then(function (data) {
        $scope.ctx.products.sourceCollection = data;
    });

    loadCartItems();

    // save items to local storage when unloading
    $(window).unload(function () {
        if (clearCart) {
            $scope.ctx.cartItems = [];
            clearCart = false;
        }
        saveCartItems();
    });

    // add item in shopping cart
    $scope.addCartItem = function (product, quantity) {
        quantity = toNumber(quantity);
        if (quantity != 0) {

            // update quantity for existing item
            var found = false;
            for (var i = 0; i < $scope.ctx.cartItems.length && !found; i++) {
                var item = $scope.ctx.cartItems[i];
                if (item.sku === product.sku) {
                    found = true;
                    item.quantity = toNumber(item.quantity + quantity);
                }
            }

            // new item, add now
            if (!found) {
                $scope.ctx.cartItems.push({
                    sku: product.sku,
                    name: product.name,
                    description: product.description,
                    abstract: product.abstract,
                    features: product.features,
                    image: product.image,
                    image_thumb: product.image_thumb,
                    price: product.price,
                    quantity: quantity
                });
            }
        }
    };

    // remove item from the shopping cart
    $scope.clearCartItem = function (sku) {
        if (sku) {
            for (var i = 0; i < $scope.ctx.cartItems.length; i++) {
                var item = $scope.ctx.cartItems[i];
                if (item.sku === sku) {
                    $scope.ctx.cartItems.splice(i, 1);
                }
            }
        } else {
            $scope.ctx.cartItems = [];
        }

        saveCartItems();
    };

    $scope.getItemPrice = function (item) {

        var price = 0;
        if (item.quantity == undefined) {
            price = roundTotals(toNumber((item.price)));
        } else {
            price = roundTotals(toNumber((item.price * item.quantity) + 0.0001));
        }


        if ($scope.ctx.clientInformation.buyer_type == 'company') {
            return $filter('currency')(price) + " + " + $filter('translate')('tax');
        } else {
            price = price + (price * ($scope.ctx.clientInformation.tax / 100));
            return $filter('currency')(price);

        }


    };

    // get the total price for all items currently in the cart
    $scope.getTotalPrice = function (sku) {
        var total = 0;
        for (var i = 0; i < $scope.ctx.cartItems.length; i++) {
            var item = $scope.ctx.cartItems[i];
            if (sku == null || item.sku == sku) {
                total += roundTotals(toNumber((item.price * item.quantity) + 0.0001));
            }
        }
        $scope.ctx.clientInformation.total_no_tax = total;
        return total;
    };

    // get the total price for all items currently in the cart
    $scope.getTotalPriceItemsList = function (sku) {
        var total = 0;
        if ($scope.ctx.clientInformation.buyer_type == 'company') {
            for (var i = 0; i < $scope.ctx.cartItems.length; i++) {
                var item = $scope.ctx.cartItems[i];
                if (sku == null || item.sku == sku) {
                    total += roundTotals(toNumber((item.price * item.quantity) + 0.0001));
                }
            }
            return $filter('currency')(total) + " + " + $filter('translate')('tax');
        } else {
            for (var i = 0; i < $scope.ctx.cartItems.length; i++) {
                var item = $scope.ctx.cartItems[i];
                if (sku == null || item.sku == sku) {
                    var price = roundTotals(toNumber((item.price * item.quantity) + 0.0001));
                    total += price + (price * ($scope.ctx.clientInformation.tax / 100));
                }
            }
            return $filter('currency')(total);
        }


    };

    $scope.getTotalWithTaxAndShippingCost = function () {
        $scope.ctx.clientInformation.total_with_tax = roundTotals(toNumber($scope.ctx.clientInformation.total_no_tax) + ((toNumber($scope.ctx.clientInformation.total_no_tax) * ($scope.ctx.clientInformation.tax / 100)) + 0.0001));
        $scope.ctx.clientInformation.total = roundTotals(toNumber($scope.ctx.clientInformation.total_with_tax) + toNumber($scope.ctx.clientInformation.shipping_cost));

        return $scope.ctx.clientInformation.total;
    };

    $scope.getTotalTax = function () {

        $scope.ctx.clientInformation.tax_value = roundTotals(toNumber(($scope.ctx.clientInformation.total) * ($scope.ctx.clientInformation.tax / 100)) + 0.0001);
        return $scope.ctx.clientInformation.tax_value;
    };

    // get the total price for all items currently in the cart
    $scope.getTotalCount = function (sku) {
        var count = 0;
        for (var i = 0; i < $scope.ctx.cartItems.length; i++) {
            var item = $scope.ctx.cartItems[i];
            if (sku == null || item.sku == sku) {
                count += toNumber(item.quantity);
            }
        }
        return count;
    };

    // checkout the shopping cart.
    $scope.checkout = function (serviceName) {
        spinner("show");
        $scope.ctx.clientInformation.total = roundTotals($scope.ctx.clientInformation.total);
        $scope.ctx.clientInformation.total_with_tax = roundTotals($scope.ctx.clientInformation.total_with_tax);
        var orderData = orderService.prepareOrderData($scope.ctx);
        orderService.storeOrderPending(siteVariables.storeOrderUrl, orderData, function (response) {
            var merchantID;
            if (serviceName === 'PayPal') {
                merchantID = 'info@icbtecnologie.com';
            } else {
                throw 'Unknown checkout service: ' + serviceName;
            }
            checkoutService.checkout(serviceName, merchantID, response.data.id, orderData.total, siteVariables.ipnRoute);
        }, function () {
            spinner("hide");
        });
    };

    // apply filter (applied on a 500 ms timeOut)
    var toFilter;
    $scope.$watch('ctx.filter', function () {
        if (toFilter) {
            clearTimeout(toFilter);
        }
        toFilter = setTimeout(function () {
            toFilter = null;
            var cv = $scope.ctx.products;
            if (cv) {
                if (cv.filter != filterFunction) {
                    cv.filter = filterFunction;
                } else {
                    cv.refresh();
                }
                $scope.$apply('ctx.products');
            }
        }, 500);
    });


    $scope.$watch('ctx.clientInformation.country', function () {
        setTaxAndShippingCostValue();
    });

    $scope.$watch('ctx.clientInformation.buyer_type', function () {
        setTaxAndShippingCostValue();
    });


    $scope.$watch('ctx.cartItems', function () {
        var j = 0;
        for (var i = 0; i < $scope.ctx.cartItems.length; i++) {
            var item = $scope.ctx.cartItems[i];
            if (item.quantity <= 0) {
                $scope.ctx.cartItems.splice(i, 1);
                i--;
            }
        }
    }, true);


    function filterFunction(item) {
        var filter = $scope.ctx.filter;

        if (filter && item) {
            var value = item['name'];
            if (angular.isString(value) && value.toUpperCase().indexOf(filter.toUpperCase()) > -1) {
                return true;
            }
            return false;
        }

        return true;
    };

    // save the shopping cart in local storage
    function saveCartItems() {
        if (localStorage != null && JSON != null) {
            localStorage['shoppingCart_items'] = JSON.stringify($scope.ctx.cartItems);
        }
    };

    // load the shopping cart from local storage
    function loadCartItems() {
        var items = localStorage != null ? localStorage['shoppingCart_items'] : null;
        if (items != null && JSON != null) {
            try {
                items = JSON.parse(items);
                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    if (item.sku != null && item.name != null && item.price != null && item.quantity != null) {
                        $scope.ctx.cartItems.push({
                            sku: item.sku,
                            name: item.name,
                            description: item.description,
                            abstract: item.abstract,
                            features: item.features,
                            image: item.image,
                            image_thumb: item.image_thumb,
                            price: item.price,
                            quantity: item.quantity
                        });
                    }
                }
            }
            catch (err) {
                // ignore errors while loading...
            }
        }
    }

    // convert the value to numeric value
    function toNumber(value) {
        value = value * 1;
        return isNaN(value) ? 0 : value;
    }

    $scope.itemStepQuantityAdd = function (item) {
        item.quantity = item.quantity + 1;
    };

    $scope.itemStepQuantityRemove = function (item) {
        if (item.quantity <= 1) {
            return;
        }
        item.quantity = item.quantity - 1;
    };

    function spinner(operation) {
        if (operation == "show") {
            $("nav.navbar.navbar-fixed-top").css("z-index", "50");
            $("div.breadcrumps").css("z-index", "50");
            $('.spinner-container').show();
            $('.spinner').addClass('animated fadeIn');
        } else {
            if (operation == "hide") {
                $("nav.navbar.navbar-fixed-top").removeAttr("style");
                $("div.breadcrumps").removeAttr("style");
                $('.spinner-container').hide();
                $('.spinner').addClass('fadeOut');
            }
        }

    }

    $scope.complete = function () {
        clearCart = true;
        if (clearCart) {
            $scope.ctx.cartItems = [];
            clearCart = false;
        }
        saveCartItems();
        $scope.ctx.clientInformation = {};
    }


    LangService.get(siteVariables.locale).then(function (data) {
        $scope.ctx.countries = data.country_options;
    }, function () {
        $scope.ctx.countries = {};
    });

    function roundTotals(value) {
        return Math.round(value * 100) / 100;
    }

    function setTaxAndShippingCostValue() {

        if ($scope.ctx.clientInformation.country != null && $scope.ctx.clientInformation.buyer_type == 'company') {
            if (isCountryItaly()) {
                $scope.ctx.clientInformation.shipping_cost = siteVariables.shipping_cost.italy;
                $scope.ctx.clientInformation.tax = siteVariables.tax;
                $scope.ctx.clientInformation.shipping_group = 'italy';
            } else {
                if (isAbroadCEE()) {
                    $scope.ctx.clientInformation.shipping_cost = siteVariables.shipping_cost.abroad;
                    $scope.ctx.clientInformation.tax = 0;
                    $scope.ctx.clientInformation.shipping_group = 'abroad';
                } else {
                    $scope.ctx.clientInformation.shipping_cost = siteVariables.shipping_cost.cee;
                    $scope.ctx.clientInformation.tax = 0;
                    $scope.ctx.clientInformation.shipping_group = 'cee';
                }
            }
        }

        if ($scope.ctx.clientInformation.country != null && $scope.ctx.clientInformation.buyer_type == 'person') {
            if (isCountryItaly()) {
                $scope.ctx.clientInformation.shipping_cost = siteVariables.shipping_cost.italy;
                $scope.ctx.clientInformation.tax = siteVariables.tax;
                $scope.ctx.clientInformation.shipping_group = 'italy';
            } else {
                if (isAbroadCEE()) {
                    $scope.ctx.clientInformation.shipping_cost = siteVariables.shipping_cost.abroad;
                    $scope.ctx.clientInformation.tax = siteVariables.tax;
                    $scope.ctx.clientInformation.shipping_group = 'abroad';
                } else {
                    $scope.ctx.clientInformation.shipping_cost = siteVariables.shipping_cost.cee;
                    $scope.ctx.clientInformation.tax = siteVariables.tax;
                    $scope.ctx.clientInformation.shipping_group = 'cee';
                }
            }
        }
    }


    function isCountryItaly() {
        return $scope.ctx.clientInformation.country.toLowerCase() == "italia" || $scope.ctx.clientInformation.country.toLowerCase() == "italy";
    }

    function isAbroadCEE() {
        return $scope.ctx.clientInformation.country.toLowerCase() == "svizzera" || $scope.ctx.clientInformation.country.toLowerCase() == "norvegia";
    }
}]);
